/*
 *
 * Absence reducer
 *
 */
import produce from 'immer';
import {
  // list
  LOAD_ABSENCES,
  LOAD_ABSENCES_SUCCESS,
  LOAD_ABSENCES_ERROR,
  CHANGE_ABSENCES,
  CHANGE_ABSENCES_SUCCESS,
  CHANGE_ABSENCES_ERROR,
  // one
  DELETE_ABSENCE,
  DELETE_ABSENCE_SUCCESS,
  DELETE_ABSENCE_ERROR,
  FLUSH_STATE_ABSENCE,
} from './constants';

export const initialState = {
  // loading
  loading: false,
  loadingUpdatedList: false,
  loadingDelete: false,
  // errors
  error: false,
  listError: false,
  dataError: false,
  deleteError: false,
  // success props
  deleteSuccessful: false,
  itemsList: false,
  list: [],
  firstElem: false,
  updatedList: [],
};

/* eslint-disable default-case, no-param-reassign */
const absenceReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ABSENCE:
        return initialState;

      // Load All
      case LOAD_ABSENCES:
        draft.loading = true;
        draft.error = false;
        draft.firstElem = false;
        break;

      case LOAD_ABSENCES_SUCCESS:
        
        draft.itemsList = action.itemsList;
        draft.firstElem = action.firstElem;
        draft.loading = false;
     
        break;

      case LOAD_ABSENCES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.itemsList = false;
        draft.firstElem = false;
        break;

      // Update for List
      case CHANGE_ABSENCES:
        draft.list = action.list;
        draft.loadingUpdatedList = true;
        draft.listError = false;

        break;

      case CHANGE_ABSENCES_SUCCESS:
        draft.loadingUpdatedList = false;
        const { updatedList } = action;
        draft.updatedList = updatedList;

        let listUpdaedData = draft.itemsList.data;
        updatedList &&
          updatedList.map(itemData => {
            const index = draft.itemsList.data.findIndex(
              po => po._id === itemData._id,
            );
            if (index !== -1) {
              listUpdaedData[index] = itemData;
            } else {
              listUpdaedData.unshift(itemData);
            }
          });
        draft.itemsList = { ...draft.itemsList, data: listUpdaedData };

        break;

      case CHANGE_ABSENCES_ERROR:
        draft.listError = action.listError;
        draft.loadingUpdatedList = false;
        draft.updatedList = [];
        break;

  
      // Delete for Single Element
      case DELETE_ABSENCE:
        draft.loadingDelete = true;
        draft.deleteError = false;
        break;

      case DELETE_ABSENCE_SUCCESS:
        draft.loadingDelete = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default absenceReducer;
